import { ReactElement } from "react";
import { useLocalization } from '@progress/kendo-react-intl';
import { enMessages } from "../../../messages/en-US";
import { SvgIcon } from "@progress/kendo-react-common";
import { warningTriangleIcon } from "@progress/kendo-svg-icons";

export default function NoDataPage(): ReactElement {
  const localizationService = useLocalization();

  return (
    <div className="gb-text-normal text-lg text-center"
      style={{ borderRadius: '3px', padding: '40px 25px', margin: '30px auto'}}>
      <div className="text-center mb-5">
        <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '72px',
          height: '72px'
        }}>
          <SvgIcon icon={warningTriangleIcon} size="xxlarge" />
        </span>
      </div>
      <div>
        <div>{`${localizationService.toLanguageString('custom.noDataFound', enMessages.custom.noDataFound)}`}</div>
        <br />
        <div>{localizationService.toLanguageString('custom.noTagsAssigned', enMessages.custom.noTagsAssigned)}</div>
      </div>
    </div> 
  );
}
